import Head from 'next/head';

export interface RSSMetaProps {
	title: string;
	url: string;
}

export const RSSMeta = ({ title, url }: RSSMetaProps) => {
	return (
		<Head>
			<link rel="alternate" type="application/rss+xml" title={title} href={url} />;
		</Head>
	);
};
